export default __webpack_public_path__ + "static/media/camerapic.b217e9fc.png";